import { Flex } from '@chakra-ui/react'
import React from 'react'
import { styles } from '../styles'
import AppTypography from 'components/common/typography/AppTypography'
import AppIcons from 'assets/icon/Appicons'

export default function MobileModeButton({ mobileModeIcon, onOpen, placeholder, fullWidth }) {
    return (
        <Flex
            {...styles.menuButton}
            onClick={onOpen}
            justifyContent="space-between"
            alignItems="center"
            cursor="pointer"
            {...mobileModeIcon && { padding: "10px" }}
            {...fullWidth && { width: "100%" }}
        >
            {
                mobileModeIcon ?
                    mobileModeIcon
                    : <>
                        <AppTypography color="text.subtext.placeholder.dark" fontSize={14} fontWeight={400}>
                            {placeholder}
                        </AppTypography>
                        <AppIcons.SelectChevronDown />
                    </>
            }
        </Flex>
    )
}
